define('formkit/model/template.object.type.model',['require','exports','module','./base.model','uuid'],function(require ,exports, module){
  var BaseModel = require('./base.model');
  var UUID      = require('uuid');

  var TemplateObjectTypeModel = BaseModel.extend({

    defaults: {
      dataLabels: []
    },
  });
  module.exports = TemplateObjectTypeModel;
});

